import React from 'react';

class DataGridCell extends React.Component {

    render () {
        let metaData = this.props.metadata || {};

        return (
            <span className="default-cell">{this.props.data || metaData.defaultValue || 'No Data To Display'}</span>
        )
    }
}

export default DataGridCell;



// WEBPACK FOOTER //
// ./web-app/components/data-grid-cell.jsx